export const HEADERS_SEARCH: HeadersInit = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${process.env.NEXT_PUBLIC_APP_SEARCH_KEY}`,
};
